module.exports = __webpack_public_path__ + "static/media/nu.4388f2f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nu.svg
// module id = 215
// module chunks = 0